(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function() {
  var cartForm = document.getElementById('cart-form');
  if (!cartForm) return;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function updateHeaderCount(count) {
    var el = document.querySelector('.site-nav__cart-count');
    if (!el) return;
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  }

  function updateItemUI(key, cartData) {
    var keySlug = key.replace(':', '-');
    var item = cartData.items.find(function(i) { return i.key === key; });

    // Update line price in item row
    var lineEl = document.getElementById('line-price-' + keySlug);
    if (lineEl && item) lineEl.textContent = formatMoney(item.line_price);

    // Update line price in summary sidebar
    var summaryEl = document.getElementById('summary-line-' + keySlug);
    if (summaryEl && item) summaryEl.textContent = formatMoney(item.line_price);

    // Update subtotal
    var subtotalEl = document.getElementById('cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cartData.total_price);

    // Update header count
    updateHeaderCount(cartData.item_count);
  }

  function removeItemUI(key) {
    var keySlug = key.replace(':', '-');
    var row = document.getElementById('cart-item-' + keySlug);
    if (row) {
      row.classList.add('is-removing');
      setTimeout(function() {
        row.remove();
        // If no items left, reload to show empty state
        if (!document.querySelector('.cart-item')) {
          window.location.reload();
        }
      }, 220);
    }
    // Remove from summary sidebar
    var summaryEl = document.getElementById('summary-line-' + keySlug);
    if (summaryEl) {
      var summaryLine = summaryEl.closest('.cart-summary__line');
      if (summaryLine) summaryLine.remove();
    }
  }

  function cartChange(key, quantity) {
    var keySlug = key.replace(':', '-');
    var row = document.getElementById('cart-item-' + keySlug);
    if (row) row.classList.add('cart-item-updating');

    var checkoutBtn = document.getElementById('cart-checkout-btn');
    if (checkoutBtn) checkoutBtn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (row) row.classList.remove('cart-item-updating');
      if (checkoutBtn) checkoutBtn.disabled = false;

      if (quantity === 0) {
        removeItemUI(key);
        updateHeaderCount(cart.item_count);
        var subtotalEl = document.getElementById('cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      } else {
        updateItemUI(key, cart);
        // Keep input in sync
        var input = document.querySelector('.cart-qty__input[data-key="' + key + '"]');
        if (input) input.value = quantity;
      }
    })
    .catch(function() {
      if (row) row.classList.remove('cart-item-updating');
      if (checkoutBtn) checkoutBtn.disabled = false;
    });
  }

  // +/- buttons
  document.querySelectorAll('.cart-qty').forEach(function(stepperEl) {
    var input = stepperEl.querySelector('.cart-qty__input');
    var key   = input ? input.dataset.key : null;
    if (!key) return;

    stepperEl.querySelector('[data-action="inc"]').addEventListener('click', function() {
      var newQty = parseInt(input.value, 10) + 1;
      cartChange(key, newQty);
    });

    stepperEl.querySelector('[data-action="dec"]').addEventListener('click', function() {
      var newQty = Math.max(0, parseInt(input.value, 10) - 1);
      cartChange(key, newQty);
    });
  });

  // Direct input change (debounced)
  var inputTimers = {};
  document.querySelectorAll('.cart-qty__input').forEach(function(input) {
    input.addEventListener('change', function() {
      var key = this.dataset.key;
      var qty = Math.max(0, parseInt(this.value, 10) || 0);
      clearTimeout(inputTimers[key]);
      inputTimers[key] = setTimeout(function() { cartChange(key, qty); }, 400);
    });
  });

  // Remove buttons
  document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      cartChange(this.dataset.key, 0);
    });
  });

  // Discount code — redirect to checkout with code applied
  var discountForm = document.getElementById('cart-discount-form');
  if (discountForm) {
    discountForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var code = document.getElementById('cart-discount-input').value.trim();
      var note = document.getElementById('cart-discount-note');
      if (!code) {
        if (note) { note.textContent = 'Please enter a discount code.'; note.className = 'cart-discount__note cart-discount__note--error'; }
        return;
      }
      if (note) { note.textContent = 'Applying code\u2026'; note.className = 'cart-discount__note'; }
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
// Description expand/collapse
(function() {
  var desc = document.getElementById('cat-desc-text');
  var btn  = document.getElementById('cat-desc-toggle');
  if (!desc || !btn) return;
  // Only show the toggle if text is actually clamped
  if (desc.scrollHeight > desc.clientHeight + 4) {
    btn.classList.add('is-visible');
  }
  btn.addEventListener('click', function() {
    var expanded = desc.classList.toggle('is-expanded');
    btn.textContent = expanded ? 'Show less' : 'Show more';
    btn.setAttribute('aria-expanded', expanded);
    if (!expanded) btn.classList.add('is-visible');
  });
})();

// View toggle
const gridEl = document.getElementById('col-products-grid');
document.getElementById('view-grid').addEventListener('click', function() {
  gridEl.className = 'col-products-grid grid-3';
  this.classList.add('active');
  document.getElementById('view-list').classList.remove('active');
  localStorage.setItem('collectionView', 'grid');
});
document.getElementById('view-list').addEventListener('click', function() {
  gridEl.className = 'col-products-grid list-view';
  this.classList.add('active');
  document.getElementById('view-grid').classList.remove('active');
  localStorage.setItem('collectionView', 'list');
});

// Restore view preference
if (localStorage.getItem('collectionView') === 'list') {
  document.getElementById('view-list').click();
}

// Collection search — fetches ALL products in collection via AJAX, not just paginated ones
var colSearchInput = document.getElementById('col-search-input');
var colSearchHint  = document.getElementById('col-search-hint');
var colSearchForm  = document.getElementById('col-search-form');

if (colSearchInput && colSearchForm) {
  var colHandle      = colSearchForm.dataset.collectionHandle || '';
  var colAllProducts = null;   // null = not yet loaded
  var colLoading     = false;
  var colTimer       = null;
  var colOrigGrid    = null;   // saved original grid HTML

  function colMoney(str) {
    var n = parseFloat(str);
    return isNaN(n) ? (str || '') : '$' + n.toFixed(2).replace(/\.00$/, '');
  }

  function colBuildCard(p) {
    var url    = '/products/' + p.handle;
    var v      = p.variants && p.variants[0] ? p.variants[0] : {};
    var price  = v.price || '0';
    var cmp    = v.compare_at_price || '0';
    var badge  = '';
    if (p.tags && p.tags.indexOf('new') !== -1) {
      badge = '<div class="col-product-badge badge-new">NEW</div>';
    } else if (parseFloat(cmp) > parseFloat(price)) {
      badge = '<div class="col-product-badge badge-sale">SALE</div>';
    }
    var imgSrc  = p.images && p.images[0] ? p.images[0].src.replace(/\?.*$/, '') + '?width=600' : null;
    var imgHtml = imgSrc
      ? '<img class="col-product-img-fill" src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
      : '<div class="col-product-img-placeholder"><span style="color:var(--text-dimmer);font-size:40px;">&#9726;</span></div>';
    var cmpHtml = parseFloat(cmp) > parseFloat(price)
      ? '<span class="col-product-price-old">' + colMoney(cmp) + '</span>' : '';
    return '<div class="col-product-card">'
      + '<a href="' + url + '" class="col-product-img-link"><div class="col-product-img">'
      + imgHtml + '<div class="col-product-overlay">QUICK VIEW &rarr;</div>' + badge
      + '</div></a><div class="col-product-info">'
      + '<a href="' + url + '" class="col-product-name">' + p.title + '</a>'
      + '<div class="col-product-compat">' + (p.product_type || p.vendor || '') + '</div>'
      + '<div class="col-product-footer"><div>'
      + '<span class="col-product-price">' + colMoney(price) + '</span>' + cmpHtml
      + '</div></div></div></div>';
  }

  function colRenderResults(q) {
    var grid = document.getElementById('col-products-grid');
    var pag  = document.querySelector('.col-pagination');
    if (!grid) return;

    if (!q) {
      if (colOrigGrid !== null) { grid.innerHTML = colOrigGrid; colOrigGrid = null; }
      if (pag) pag.style.display = '';
      if (colSearchHint) { colSearchHint.textContent = ''; colSearchHint.className = 'col-search__hint'; }
      return;
    }

    if (colOrigGrid === null) colOrigGrid = grid.innerHTML;
    if (pag) pag.style.display = 'none';

    var ql      = q.toLowerCase();
    var matches = (colAllProducts || []).filter(function(p) {
      var text = p.title + ' ' + (p.product_type || '') + ' ' + (p.vendor || '') + ' ' + (p.tags || []).join(' ');
      return text.toLowerCase().indexOf(ql) !== -1;
    });

    if (matches.length === 0) {
      grid.innerHTML = '<div class="col-empty-state">'
        + '<div class="col-empty-icon">&#9726;</div>'
        + '<h3 class="col-empty-title">No products found</h3>'
        + '<p class="col-empty-body">No products in this collection match &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;.</p>'
        + '</div>';
      if (colSearchHint) {
        colSearchHint.textContent = 'No results — try a different term or press Enter to search the full store.';
        colSearchHint.className = 'col-search__hint col-search__hint--none';
      }
    } else {
      grid.innerHTML = matches.map(colBuildCard).join('');
      if (colSearchHint) {
        colSearchHint.textContent = matches.length + ' product' + (matches.length === 1 ? '' : 's') + ' found in this collection.';
        colSearchHint.className = 'col-search__hint';
      }
    }
  }

  function colFetchAll(cb) {
    if (!colHandle) { cb(); return; }
    var all = [];
    function getPage(n) {
      fetch('/collections/' + colHandle + '/products.json?limit=250&page=' + n)
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var batch = d.products || [];
          all = all.concat(batch);
          if (batch.length === 250) { getPage(n + 1); } else { colAllProducts = all; cb(); }
        })
        .catch(function() { colAllProducts = all; cb(); });
    }
    getPage(1);
  }

  function colRunSearch(q) {
    var grid = document.getElementById('col-products-grid');
    if (!q) { colRenderResults(''); return; }

    if (colAllProducts !== null) { colRenderResults(q); return; }

    if (!colLoading) {
      colLoading = true;
      if (colOrigGrid === null && grid) colOrigGrid = grid.innerHTML;
      if (grid) grid.innerHTML = '<div class="col-search-loading">Loading collection&hellip;</div>';
      if (colSearchHint) { colSearchHint.textContent = ''; }
      colFetchAll(function() {
        colLoading = false;
        colRenderResults(colSearchInput.value.trim());
      });
    }
  }

  colSearchInput.addEventListener('input', function() {
    var q = this.value.trim();
    clearTimeout(colTimer);
    if (!q) { colRunSearch(''); return; }
    colTimer = setTimeout(function() { colRunSearch(q); }, 300);
  });

  colSearchInput.addEventListener('search', function() {
    if (!this.value) colRunSearch('');
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-orders"] && !Shopify.designMode) return;
  try {
    
(function() {
  var coCurrentStep = 1;
  var coMaxReached = 1; // tracks how far the user has progressed

  // ── Validate a given step, return true if valid ──
  function validateStep(n) {
    if (n === 1) {
      var brand = document.getElementById('brand');
      var model = document.getElementById('model');
      var ok = true;
      if (!brand || !brand.value.trim()) {
        if (brand) brand.classList.add('error');
        var e = document.getElementById('err-brand');
        if (e) e.classList.add('show');
        ok = false;
      } else {
        brand.classList.remove('error');
        var e = document.getElementById('err-brand');
        if (e) e.classList.remove('show');
      }
      if (!model || !model.value.trim()) {
        if (model) model.classList.add('error');
        var e = document.getElementById('err-model');
        if (e) e.classList.add('show');
        ok = false;
      } else {
        model.classList.remove('error');
        var e = document.getElementById('err-model');
        if (e) e.classList.remove('show');
      }
      return ok;
    }
    return true; // steps 2 and 3 have no required fields
  }

  // ── Navigate to step n ──
  window.coGoStep = function(n) {
    // Allow going back freely; going forward requires validating current step
    if (n > coCurrentStep) {
      if (!validateStep(coCurrentStep)) return;
    }
    // Don't allow skipping ahead past max reached + 1
    if (n > coMaxReached + 1) return;

    document.querySelectorAll('.form-step').forEach(function(s) { s.classList.remove('active'); });
    var target = document.getElementById('step-' + n);
    if (target) target.classList.add('active');

    document.querySelectorAll('.progress-step').forEach(function(s, i) {
      s.classList.remove('active', 'done');
      if (i + 1 < n) s.classList.add('done');
      if (i + 1 === n) s.classList.add('active');
    });

    coCurrentStep = n;
    if (n > coMaxReached) coMaxReached = n;

    var formBody = document.querySelector('.form-body');
    if (formBody) formBody.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  // ── Compile hidden fields + build email body on submit ──
  var submitBtn = document.getElementById('btn-submit');
  if (submitBtn) {
    var form = submitBtn.closest('form');
    form.addEventListener('submit', function(e) {
      // Validate step 4 contact fields
      var fname = document.getElementById('contact-fname');
      var lname = document.getElementById('contact-lname');
      var emailField = document.getElementById('contact-email');
      var ok = true;

      if (!emailField || !emailField.value.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailField.value.trim())) {
        var er = document.getElementById('err-email');
        if (er) er.classList.add('show');
        if (emailField) emailField.classList.add('error');
        ok = false;
      } else {
        var er = document.getElementById('err-email');
        if (er) er.classList.remove('show');
        emailField.classList.remove('error');
      }
      if (!ok) { e.preventDefault(); return; }

      // Gather values
      var brandVal    = document.getElementById('brand').value.trim();
      var modelVal    = document.getElementById('model').value.trim();
      var rackEl      = document.querySelector('input[name="rack-type-ui"]:checked');
      var rackVal     = rackEl ? rackEl.value : '';
      var contextVal  = (document.getElementById('context') || {}).value || '';
      var dimW        = (document.getElementById('dim-w') || {}).value || '';
      var dimD        = (document.getElementById('dim-d') || {}).value || '';
      var dimH        = (document.getElementById('dim-h') || {}).value || '';
      var dimsVal     = [dimW && 'W:'+dimW+'mm', dimD && 'D:'+dimD+'mm', dimH && 'H:'+dimH+'mm'].filter(Boolean).join(', ') || 'Not provided';
      var portVal     = (document.getElementById('port-notes') || {}).value || '';
      var matEl       = document.querySelector('input[name="material-ui"]:checked');
      var matVal      = 'PETG';
      if (matEl && matEl.dataset.other === 'true') {
        matVal = (document.getElementById('other-material-text') || {}).value || 'Special Request';
      } else if (matEl) {
        matVal = matEl.value;
      }
      var colEl       = document.querySelector('input[name="color-ui"]:checked');
      var colVal      = colEl ? colEl.value : 'Matte Black';
      if (colEl && colEl.dataset.custom === 'true') colVal = (document.getElementById('custom-color-text') || {}).value || colVal;
      var keystoneVal = (document.getElementById('keystone-val') || {}).value || '0';
      var refEl       = document.getElementById('contact-referral');
      var refVal      = refEl ? refEl.value : '';
      var fnameVal    = fname ? fname.value.trim() : '';
      var lnameVal    = lname ? lname.value.trim() : '';
      var fullName    = [fnameVal, lnameVal].filter(Boolean).join(' ') || 'Not provided';

      // Populate contact[name] for Shopify
      document.getElementById('h-name').value = fullName;

      // Populate individual hidden fields (appear in Shopify email as extra properties)
      document.getElementById('h-brand').value    = brandVal;
      document.getElementById('h-model').value    = modelVal;
      document.getElementById('h-rack').value     = rackVal;
      document.getElementById('h-context').value  = contextVal;
      document.getElementById('h-dims').value     = dimsVal;
      document.getElementById('h-ports').value    = portVal;
      document.getElementById('h-material').value  = matVal;
      document.getElementById('h-color').value     = colVal;
      document.getElementById('h-keystones').value = keystoneVal;
      document.getElementById('h-referral').value  = refVal;

      // Build a readable email body
      var body = [
        '=== CUSTOM MOUNT REQUEST ===',
        '',
        'CUSTOMER: ' + fullName,
        'EMAIL: ' + emailField.value.trim(),
        refVal ? 'REFERRAL: ' + refVal : '',
        '',
        '--- DEVICE INFO ---',
        'Brand:    ' + brandVal,
        'Model:    ' + modelVal,
        'Rack:     ' + rackVal,
        contextVal ? 'Notes:    ' + contextVal : '',
        '',
        '--- DIMENSIONS ---',
        'Size:  ' + dimsVal,
        portVal ? 'Ports: ' + portVal : '',
        '',
        '--- MATERIAL & FINISH ---',
        'Material:  ' + matVal,
        'Color:     ' + colVal,
        'Keystones: ' + keystoneVal,
        '',
        '==========================='
      ].filter(function(l) { return l !== undefined; }).join('\n');

      document.getElementById('h-body').value = body;

      // Remove the first_name/last_name fields so Shopify doesn't treat them as extra contact properties
      if (fname) fname.removeAttribute('name');
      if (lname) lname.removeAttribute('name');
    });
  }


  // ── Keystone picker ──
  window.coSetKeystone = function(btn) {
    document.querySelectorAll('.keystone-btn').forEach(function(b) { b.classList.remove('keystone-btn--active'); });
    btn.classList.add('keystone-btn--active');
    var field = document.getElementById('keystone-val');
    if (field) field.value = btn.dataset.val;
  };

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-item').forEach(function(item) {
    item.querySelector('.faq-q').addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var filters    = document.querySelectorAll('#fp-filters .fp-filter');
  var grid       = document.getElementById('fp-grid');
  if (!filters.length || !grid) return;

  var collection = grid.dataset.collection;
  var limit      = parseInt(grid.dataset.limit) || 8;
  var allProducts = null;       // cached after first fetch
  var initialHTML = grid.innerHTML;  // preserve Liquid-rendered "All" cards

  function money(cents) {
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    return '$' + (n / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getPrice(p) {
    // price_min, price, or first variant price — whichever is available
    if (p.price_min != null) return p.price_min;
    if (p.price != null) return p.price;
    return p.variants && p.variants[0] ? p.variants[0].price : 0;
  }

  function getCompare(p) {
    if (p.compare_at_price_min != null) return p.compare_at_price_min;
    if (p.compare_at_price != null) return p.compare_at_price;
    return p.variants && p.variants[0] ? p.variants[0].compare_at_price : null;
  }

  function cardHTML(p) {
    var img    = p.images && p.images[0]
      ? '<img src="' + p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') + '" alt="' + p.title.replace(/"/g, '&quot;') + '" class="product-card__img" loading="lazy" width="600" height="450">'
      : '<div class="product-card__img-placeholder"></div>';
    var tags    = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(', ');
    var isNew   = tags.some(function(t) { return t.toLowerCase() === 'new'; });
    var price   = getPrice(p);
    var compare = getCompare(p);
    var onSale  = compare && parseInt(compare) > parseInt(price);
    var badge   = isNew   ? '<span class="product-card__badge product-card__badge--new">NEW</span>'
                : onSale  ? '<span class="product-card__badge product-card__badge--sale">SALE</span>'
                : '';
    var compat  = [p.product_type, p.vendor].filter(Boolean).join(' &middot; ');
    var compareHtml = onSale ? '<span class="product-card__compare">' + money(compare) + '</span>' : '';
    return '<div class="product-card">'
      + '<div class="product-card__img-wrap">' + img + '<div class="product-card__overlay"></div>' + badge + '</div>'
      + '<div class="product-card__body">'
      + '<a href="/products/' + p.handle + '" class="product-card__name">' + p.title + '</a>'
      + '<p class="product-card__compat">' + compat + '</p>'
      + '<div class="product-card__pricing"><span class="product-card__price">' + money(price) + '</span>' + compareHtml + '</div>'
      + '</div></div>';
  }

  function setLoading() {
    grid.style.opacity = '0.4';
    grid.style.pointerEvents = 'none';
  }
  function clearLoading() {
    grid.style.opacity = '';
    grid.style.pointerEvents = '';
  }

  async function fetchAll() {
    if (allProducts) return allProducts;
    var products = [], page = 1;
    while (true) {
      var res  = await fetch('/collections/' + collection + '/products.json?limit=250&page=' + page);
      var data = await res.json();
      products = products.concat(data.products || []);
      if (!data.products || data.products.length < 250) break;
      page++;
    }
    allProducts = products;
    return products;
  }

  function renderFiltered(products, tag) {
    var filtered = tag === 'all'
      ? products.slice(0, limit)
      : products.filter(function(p) {
          var tags = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(', ');
          return tags.some(function(t) { return t.toLowerCase() === tag.toLowerCase(); });
        }).slice(0, limit);
    grid.innerHTML = filtered.length
      ? filtered.map(cardHTML).join('')
      : '<p class="fp-empty">No products found for this filter.</p>';
  }

  filters.forEach(function(btn) {
    btn.addEventListener('click', async function() {
      var tag = this.dataset.tag;

      filters.forEach(function(b) { b.classList.remove('fp-filter--active'); });
      this.classList.add('fp-filter--active');

      if (tag === 'all' && allProducts === null) {
        // Restore the fast Liquid-rendered initial cards
        grid.innerHTML = initialHTML;
        return;
      }

      if (!collection) return;

      setLoading();
      try {
        var products = await fetchAll();
        renderFiltered(products, tag);
      } catch(e) {
        console.error('[fp-filter] failed:', e);
      } finally {
        clearLoading();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-typing"] && !Shopify.designMode) return;
  try {
    
(function() {
  var el = document.getElementById('ht-typing');
  if (!el) return;

  var wordsRaw = el.dataset.words;
  if (!wordsRaw) return;

  var words   = wordsRaw.split('|').map(function(w) { return w.trim(); }).filter(Boolean);
  if (!words.length) return;

  var idx       = 0;
  var charIdx   = 0;
  var deleting  = false;
  var PAUSE     = 1800;   // ms to hold full word
  var TYPE_SPD  = 80;     // ms per char typing
  var DEL_SPD   = 40;     // ms per char deleting

  function tick() {
    var word    = words[idx];
    var current = word.slice(0, charIdx);
    el.textContent = current;

    if (!deleting && charIdx < word.length) {
      charIdx++;
      setTimeout(tick, TYPE_SPD);
    } else if (!deleting && charIdx === word.length) {
      deleting = true;
      setTimeout(tick, PAUSE);
    } else if (deleting && charIdx > 0) {
      charIdx--;
      setTimeout(tick, DEL_SPD);
    } else {
      deleting = false;
      idx = (idx + 1) % words.length;
      setTimeout(tick, 300);
    }
  }

  tick();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
const _reveals = document.querySelectorAll('.reveal');
const _revealObs = new IntersectionObserver(entries => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('visible'); _revealObs.unobserve(e.target); }
  });
}, { threshold: 0.1 });
_reveals.forEach(el => _revealObs.observe(el));

(function() {
  const wrap = document.querySelector('.hero__slider');
  if (!wrap) return;
  const slides = wrap.querySelectorAll('.hero__slide');
  const dots = wrap.querySelectorAll('.hero__dot');
  const total = slides.length;
  if (total <= 1) return;

  let current = 0;
  let timer;

  function goTo(n) {
    slides[current].classList.remove('hero__slide--active');
    if (dots[current]) dots[current].classList.remove('hero__dot--active');
    current = (n + total) % total;
    slides[current].classList.add('hero__slide--active');
    if (dots[current]) dots[current].classList.add('hero__dot--active');
  }

  function startAuto() { timer = setInterval(function() { goTo(current + 1); }, 5000); }
  function stopAuto() { clearInterval(timer); }

  const prevBtn = wrap.querySelector('.hero__slider-prev');
  const nextBtn = wrap.querySelector('.hero__slider-next');
  if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); goTo(current - 1); startAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); goTo(current + 1); startAuto(); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { stopAuto(); goTo(i); startAuto(); });
  });

  wrap.addEventListener('mouseenter', stopAuto);
  wrap.addEventListener('mouseleave', startAuto);

  startAuto();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage"] && !Shopify.designMode) return;
  try {
    
const reveals = document.querySelectorAll('.reveal');
const obs = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }});
}, { threshold: 0.1 });
reveals.forEach(el => obs.observe(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Accordion
  document.querySelectorAll('.faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item    = this.closest('.faq-item');
      var answer  = item.querySelector('.faq-a');
      var isOpen  = item.classList.contains('open');

      // Close all in same list
      var list = item.closest('.faq-list');
      list.querySelectorAll('.faq-item.open').forEach(function(o) {
        o.classList.remove('open');
        var a = o.querySelector('.faq-a');
        a.hidden = true;
        o.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('open');
        answer.hidden = false;
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Category tabs
  var tabs = document.querySelectorAll('.faq-tab');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('faq-tab--active'); });
      this.classList.add('faq-tab--active');
      var cat = this.dataset.cat;
      document.querySelectorAll('.faq-group').forEach(function(g) {
        if (g.dataset.group === cat) { g.removeAttribute('hidden'); }
        else { g.setAttribute('hidden', ''); }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
(function() {
  // ── Variant data (read from JSON script tags, not Liquid) ──
  var variantsEl = document.getElementById('product-variants-json');
  var optionsEl  = document.getElementById('product-options-json');
  if (!variantsEl || !optionsEl) return;
  var variants = JSON.parse(variantsEl.textContent);
  var options  = JSON.parse(optionsEl.textContent);

  // Current selections (mirror defaults from selected variant)
  var current = (function() {
    var sel = {};
    var defaultVariant = variants.find(function(v) { return v.available; }) || variants[0];
    if (defaultVariant) {
      options.forEach(function(opt, i) {
        sel[i] = defaultVariant.options[i];
      });
    }
    return sel;
  })();

  function findVariant() {
    return variants.find(function(v) {
      return options.every(function(_, i) {
        return v.options[i] === current[i];
      });
    }) || null;
  }

  function updatePrice(variant) {
    var priceEl = document.getElementById('product-price');
    var stickyPrice = document.getElementById('sticky-price');
    if (!priceEl || !variant) return;

    var fmt = function(cents) {
      return (window.Shopify && window.Shopify.formatMoney)
        ? Shopify.formatMoney(cents)
        : '$' + (cents / 100).toFixed(2);
    };

    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html = '<span class="product-buybox__price product-buybox__price--sale">' + fmt(variant.price) + '</span>'
           + '<span class="product-buybox__compare">' + fmt(variant.compare_at_price) + '</span>';
    } else {
      html = '<span class="product-buybox__price">' + fmt(variant.price) + '</span>';
    }
    priceEl.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = fmt(variant.price);
  }

  function updateATCBtn(variant) {
    var btn = document.getElementById('add-to-cart-btn');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    var available = variant && variant.available;
    var label = available ? 'Add to Cart' : 'Sold Out';
    [btn, stickyBtn].forEach(function(el) {
      if (!el) return;
      el.textContent = label;
      el.disabled = !available;
    });
  }

  function updateVariantInput(variant) {
    var input = document.getElementById('variant-id');
    if (input && variant) input.value = variant.id;
  }

  function onOptionChipClick(e) {
    var chip = e.currentTarget;
    var optIndex = parseInt(chip.dataset.optionIndex, 10);
    var value = chip.dataset.value;

    // Update current selection
    current[optIndex] = value;

    // Update chip UI
    var allChips = document.querySelectorAll('[data-option-index="' + optIndex + '"]');
    allChips.forEach(function(c) { c.classList.remove('selected'); });
    chip.classList.add('selected');

    // Update selected label
    var label = document.getElementById('option-selected-' + optIndex);
    if (label) label.textContent = value;

    // Update variant
    var variant = findVariant();
    if (variant) {
      updatePrice(variant);
      updateATCBtn(variant);
      updateVariantInput(variant);
    }
  }

  // Bind option chips
  document.querySelectorAll('.option-chip').forEach(function(chip) {
    chip.addEventListener('click', onOptionChipClick);
  });

  // ── Gallery thumbnails ──
  var mainImg = document.getElementById('gallery-main-img');
  document.querySelectorAll('.product-gallery__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      if (mainImg) {
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
        }, 150);
      }
      document.querySelectorAll('.product-gallery__thumb').forEach(function(t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  // ── Quantity stepper ──
  var qtyInput = document.getElementById('qty-input');
  document.getElementById('qty-minus') && document.getElementById('qty-minus').addEventListener('click', function() {
    var v = parseInt(qtyInput.value, 10);
    if (v > 1) qtyInput.value = v - 1;
  });
  document.getElementById('qty-plus') && document.getElementById('qty-plus').addEventListener('click', function() {
    var v = parseInt(qtyInput.value, 10);
    qtyInput.value = v + 1;
  });

  // ── Tab switching ──
  document.querySelectorAll('.product-tab__btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.dataset.tab;
      document.querySelectorAll('.product-tab__btn').forEach(function(b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.product-tab__panel').forEach(function(p) {
        p.classList.remove('active');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      var panel = document.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  // ── Sticky ATC bar ──
  var stickyBar = document.getElementById('sticky-atc');
  var stickyBtn = document.getElementById('sticky-atc-btn');
  var mainAtcBtn = document.getElementById('add-to-cart-btn');
  var anchorEl = document.getElementById('product-form-anchor');
  var formId = anchorEl ? anchorEl.dataset.formId : '';

  if (stickyBar && mainAtcBtn) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        } else {
          stickyBar.classList.add('visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.2 });
    observer.observe(mainAtcBtn);
  }

  // Sticky ATC submits the main form
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      var mainForm = document.getElementById(formId);
      if (mainForm) mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
    });
  }

  // ── Scroll reveal ──
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function(el) { revealObserver.observe(el); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  const WORKER_URL = document.getElementById('rf-form-wrap')?.dataset.workerUrl || '';

  // Read URL params to pre-fill product/sku/name
  const params = new URLSearchParams(window.location.search);
  const productName = params.get('product') || '';
  const sku = params.get('sku') || '';
  const customerName = params.get('name') || '';

  if (productName) {
    document.getElementById('rf-product-name').textContent = productName;
    document.getElementById('rf-product-row').style.display = '';
  }
  if (sku) document.getElementById('rf-sku').value = sku;
  if (customerName) document.getElementById('rf-name').value = customerName;

  // Star rating
  let currentRating = 5;
  const stars = document.querySelectorAll('.rf-star');
  const ratingInput = document.getElementById('rf-rating');

  function setRating(val) {
    currentRating = val;
    ratingInput.value = val;
    stars.forEach(s => {
      s.classList.toggle('rf-star--on', parseInt(s.dataset.val) <= val);
    });
  }
  setRating(5);

  stars.forEach(star => {
    star.addEventListener('click', () => setRating(parseInt(star.dataset.val)));
    star.addEventListener('mouseenter', () => {
      stars.forEach(s => s.classList.toggle('rf-star--on', parseInt(s.dataset.val) <= parseInt(star.dataset.val)));
    });
  });
  document.getElementById('rf-stars').addEventListener('mouseleave', () => setRating(currentRating));

  // Char count
  const bodyEl = document.getElementById('rf-body');
  const charNum = document.getElementById('rf-char-num');
  bodyEl.addEventListener('input', () => { charNum.textContent = bodyEl.value.length; });

  // Photo upload preview
  const imageInput = document.getElementById('rf-image');
  const previewWrap = document.getElementById('rf-preview-wrap');
  const previewImg = document.getElementById('rf-preview-img');
  const uploadPrompt = document.getElementById('rf-upload-prompt');
  const removeBtn = document.getElementById('rf-remove-img');

  imageInput.addEventListener('change', () => {
    const file = imageInput.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => {
      previewImg.src = e.target.result;
      previewWrap.style.display = '';
      uploadPrompt.style.display = 'none';
    };
    reader.readAsDataURL(file);
  });

  removeBtn.addEventListener('click', () => {
    imageInput.value = '';
    previewWrap.style.display = 'none';
    uploadPrompt.style.display = '';
    previewImg.src = '';
  });

  // Form submit
  const form = document.getElementById('rf-form');
  const submitBtn = document.getElementById('rf-submit');
  const submitLabel = document.getElementById('rf-submit-label');
  const errorEl = document.getElementById('rf-error');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.style.display = '';
    errorEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function hideError() { errorEl.style.display = 'none'; }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    hideError();

    const name = document.getElementById('rf-name').value.trim();
    const body = bodyEl.value.trim();

    if (!name) { showError('Please enter your name.'); return; }
    if (body.length < 10) { showError('Please write at least 10 characters in your review.'); return; }
    if (!WORKER_URL) { showError('Review submission is not configured yet.'); return; }

    submitBtn.disabled = true;
    submitLabel.textContent = 'Submitting…';

    const fd = new FormData(form);

    try {
      const res = await fetch(WORKER_URL + '/submit', { method: 'POST', body: fd });
      const data = await res.json();
      if (!data.ok) throw new Error(data.error || 'Submission failed.');

      document.getElementById('rf-form-wrap').style.display = 'none';
      document.getElementById('rf-header').style.display = 'none';
      document.getElementById('rf-success').style.display = '';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      showError(err.message.replace('Validation: ', ''));
      submitBtn.disabled = false;
      submitLabel.textContent = 'Submit review';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
